<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/clothmanagement/details/list'

export default {
  name: "detail",
  mixins: [curdMixins],
  components: {
    list,
  },
  methods: {
  }
  
};
</script>